import { render } from "./table-box.vue?vue&type=template&id=b649c532&scoped=true"
import script from "./table-box.vue?vue&type=script&lang=ts"
export * from "./table-box.vue?vue&type=script&lang=ts"

import "./table-box.vue?vue&type=style&index=0&id=b649c532&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b649c532"

export default script